import type { IRegisterCompanyForm, IRegisterPersonForm } from '@/schemas/auth/authFormSchemas'

/** Constantes do domínio auth (login, cadastro e recuperação de senha). */

/** Login com o Google: o glofi-auth registra o cliente (`set-glofi-token`) e volta para /social-login?c=. */
export const SOCIAL_LOGIN_URL = 'https://oauth.glofi.com.br/auth/google'

/** Aviso de sucesso de todos os logins (e-mail e senha, social, sem conta e suporte). */
export const LOGIN_SUCCESS_MESSAGE = 'Login realizado com sucesso!'

/** O link de recuperação vale 5 minutos depois do envio (texto que a tela mostra junto da resposta). */
export const PASSWORD_LINK_EXPIRATION_NOTICE = 'O link expira 5 minutos após o envio.'

/**
 * Campos do ModelState da API -> campos do formulário, para o `fieldMap` do useFormAction (os demais erros viram o
 * aviso genérico).
 */
export const REGISTER_PERSON_FIELD_MAP = {
    Email: 'email',
    MainDocNumber: 'cpf',
    Password: 'password',
    Occupation: 'occupation',
} as const satisfies Partial<Record<string, keyof IRegisterPersonForm>>

export const REGISTER_COMPANY_FIELD_MAP = {
    Email: 'email',
    MainDocNumber: 'cnpj',
    Name: 'corporateName',
    Password: 'password',
    Occupation: 'occupation',
    InscricaoEstadual: 'inscricaoEstadual',
    InscricaoMunicipal: 'inscricaoMunicipal',
} as const satisfies Partial<Record<string, keyof IRegisterCompanyForm>>
